import React, { Component } from 'react';
class ModalBody extends Component {
    
    componentDidMount(){
    //    console.log(this.props.tableData);
    }
    render () {
        const bodyAttributes = (this.props.bodyAttributes)?this.props.bodyAttributes:{};
        return (
            <div className="modal-body" {...bodyAttributes}>
                {this.props.children}
            </div>
       
            
        )
    }
}

export default ModalBody;